import { useTheme } from "@mui/material";
import { ImpactRating } from "./impact-updated";

export function useGetImpactColorUpdated(rating: ImpactRating["rating"]) {
  const theme = useTheme();

  let normalizedRating = rating?.toLowerCase();

  if (normalizedRating === "none") {
    return theme.palette.none.main;
  } else if (normalizedRating === "low") {
    return theme.palette.low.main;
  } else if (normalizedRating === "medium") {
    return theme.palette.medium.main;
  } else if (normalizedRating === "high") {
    return theme.palette.high.main;
  } else if (normalizedRating === "unscored") {
    return theme.palette.unscored.main;
  } else if (normalizedRating === "error") {
    return theme.palette.errorScan.main;
  } else {
    return theme.palette.critical.main;
  }
}
